import Log from 'loglevel';
import Vue from 'vue';
import Vuex from 'vuex';
//import KHDev from '../assets/KH_look.jpg';
//import Doser from '../assets/doser.jpg';
//import Tube from '../assets/tube.jpg';

let PURL = (process.env.SERVER || "aquawizserver-whatsupbro.rhcloud.com");
Vue.use(Vuex);

// Object Vuex.Store
const StoreData = {
  // Vuex Store properties
  state: {
    message: '',

    user: {
      name: '',
      token: {},
      password: '',
      email: '',
      status: '',
      data: {}
    },

    forSale: [{
      invId: 0,
      name: 'KH Controller',
      // image: '//placehold.it/200',
      image: "",  //KHDev,
      price: 799.99,
      quantity: 0,
      supply: 4
      /*  get supply number from database, not working!!!
      supply: (function() {
        // TBD
        var url = PURL + '/api/v1/supply';
        var data = {username: 'example'};
        var supply = { number: 5 };
        fetch(url, {
          method: 'GET',
          mode: 'no-cors',
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        }).then((res) => {
          //Log.info('supply data: ', res);
          supply.number = 10;
        }).catch((err) => {
          Log.info('err: supply: ', err);
          supply.number = 1;
        });
        return supply.number;
      })()
      */
    }, {
      invId: 1,
      name: 'Dosing Pump',
      image: "", //Doser,
      price: 23,
      quantity: 0,
      supply: 4
    }, {
      invId: 2,
      name: 'Dosing Tube',
      image: "", //Tube,
      price: 10,
      quantity: 0,
      supply: 4
    } ],
    inCart: [],
    payments: []
  },
  getters: {
    forSale: (state) => state.forSale,
    inCart: (state) => state.inCart,
    user: (state) => state.user,
    payment: (state) => state.payments.slice(-1)[0] || undefined,
  },
  mutations: {
    CHANGE_MSG(state, newMsg) {
      state.message = newMsg;
    },
    ADD_TO_CART(state, invId) {
      let item = Object.assign({}, state.forSale[invId]);
      if (state.forSale[invId].supply > 0) {
        state.forSale[invId].quantity++;
        state.forSale[invId].supply--;

        item.quantity = 1;
        state.inCart.push(item);
        Log.info("cart: ", state.forSale, invId, state);
      }
      Log.debug("adding to cart: ", state);
    },
    EMPTY_CART(state, user) {
      state.inCart = [];
    },
    REMOVE_FROM_CART(state, invId) {
      let item;
      let cart = state.inCart;
      if (state.forSale[invId].quantity > 0) {
        state.forSale[invId].quantity--;
        state.forSale[invId].supply++;
        for (let i = 0; i < cart.length; i++) {
          if (cart[i].invId === invId) {
            item = state.inCart.splice(i, 1);
            break;
          }
        }
      }
      // let item = state.inCart.splice(invId, 1);
      // TBD
      Log.info("removing: ", invId, item, state.length);
    },
    DO_TRANS(state, trans) {
      state.payments.push(trans);
    },
    GET_SUPPLY(state, invId) {
      Log.info("inCart: ",  state.inCart[invId]);
      Log.info("forSale: ",  state.forSale[invId]);

    },
    SET_SUPPLY(state, supply) {
    },
    SET_USER(state, user) {
      for (let prop in user) {
        state.user[prop] = user[prop];
      }
    }
  },
  actions: {
    addToCart(context, invId) {
      context.commit('ADD_TO_CART', invId);
    },
    emptyCart(context, user) {
      context.commit('EMPTY_CART', user);
    },
    removeFromCart(context, index) {
      context.commit('REMOVE_FROM_CART', index);
    },
    getSupply(context, supply) {
      context.commit('GET_SUPPLY', invId);
    },
    setSupply(context, supply) {
      context.commit('SET_SUPPLY', supply);
    },
    setUser(context, user) {
      context.commit('SET_USER', user);
    },
    addTrans(context, trans) {
      context.commit('DO_TRANS', trans);
    },


  }
};

export default new Vuex.Store(StoreData);



// WEBPACK FOOTER //
// ./src/store/index.js